var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { attrs: { "primary-title": "" } },
        [
          _c("div", [
            _c("h3", { staticClass: "headline mb-0" }, [_vm._v("General")]),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              nativeOn: {
                click: function ($event) {
                  _vm.show = !_vm.show
                },
              },
            },
            [
              _c("v-icon", [
                _vm._v(
                  _vm._s(_vm.show ? "fas fa-chevron-up" : "fas fa-chevron-down")
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
        },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm5: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Name" },
                    on: { input: _vm.changed },
                    model: {
                      value: _vm.system.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.system, "name", $$v)
                      },
                      expression: "system.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { sm1: "" } }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm5: "" } },
                [
                  _c("v-textarea", {
                    attrs: { label: "Description" },
                    on: { input: _vm.changed },
                    model: {
                      value: _vm.system.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.system, "description", $$v)
                      },
                      expression: "system.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "mr-4 was-orange",
              attrs: {
                color: "primary",
                outlined: "",
                rounded: "",
                disabled: !_vm.applyEnabled,
              },
              on: { click: _vm.reset },
            },
            [_vm._v("Reset")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "was-orange",
              attrs: {
                color: "primary",
                rounded: "",
                disabled: !_vm.applyEnabled,
              },
              on: { click: _vm.apply },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }